<template lang="html">
    <div class="full-container">
        <!-- toolbar, header of the test modal -->
        <!-- #region Toolbar -->
        <v-toolbar class="modal-header">
            <div class="app-logo">
                <img src="../../../assets/img/logo_s_pink.svg" />
            </div>
            <v-btn flat @click.native="onClose">
                <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title >Contrôle - {{product_name}}</v-toolbar-title>
        </v-toolbar>
        <!-- #endregion -->

        <!-- aside, all the elements to test on the side part -->
        <!-- #region Comments Aside -->
        <div class="comments-aside">
            <div column class="scroll-y">
                <ul>
                    <!-- first element -- All features -->
                    <li class="item" v-if="$_.find(requests, r => r.title == 'Features_'+params.product_id)">
                        <a @click="selectRequest(0)">
                            <v-layout column justify-space-around align-content-space-around :class="{'current-item': selectedRequest.id == $_.find(requests, r => r.title == 'Features_'+params.product_id).id && final == false, 'item-container': true}">
                                <v-flex class="item-title" >
                                    Caractéristiques produit
                                    <v-spacer></v-spacer>
                                    <template v-if="$_.find(requests, r => r.title == 'Features_'+params.product_id)">
                                        <span class="status" :style="'backgroundColor:'+$_.find(TestElementStatuses,e => e.value == $_.find(requests, r => r.title == 'Features_'+params.product_id).status).color"></span>
                                    </template>
                                </v-flex>
                            </v-layout>
                        </a>
                    </li>
                    <!-- then accessories -->
                    <li class="item" v-if="$_.find(requests, r => r.title == 'Accessories_'+params.product_id)">
                        <a @click="selectRequest(1)">
                            <v-layout column justify-space-around align-content-space-around :class="{'current-item':selectedRequest.id == $_.find(requests, r => r.title == 'Accessories_'+params.product_id).id && final == false, 'item-container': true}">
                                <v-flex class="item-title">
                                    Accessoires
                                    <v-spacer></v-spacer>
                                    <template v-if="$_.find(requests, r => r.title == 'Accessories_'+params.product_id)">
                                        <span class="status" :style="'backgroundColor:'+$_.find(TestElementStatuses,e => e.value == $_.find(requests, r => r.title == 'Accessories_'+params.product_id).status).color"></span>
                                    </template>
                                </v-flex>
                            </v-layout>
                        </a>
                    </li>
                    <!-- all requests -->
                    <li class="item">
                        <v-layout column justify-space-around align-content-space-around :class="{'item-container': true}">
                            <v-flex class="item-title">
                                <b>Demandes</b>
                                <v-spacer></v-spacer>
                            </v-flex>
                            <ul>
                                <li v-for="(element,index) in requests" :key="index" class="item" v-if="!element.title.includes(params.product_id)">
                                    <a @click="selectRequest(index)">
                                        <v-layout column justify-space-around align-content-space-around :class="{'current-item': element.id === selectedRequest.id && final == false, 'item-container': true, 'unclick' : index > first_not_saved}">
                                            <v-flex class="item-title">
                                                <p class="mb-0">{{element.title}}</p>
                                                <v-spacer></v-spacer>
                                                <span class="status" :style="'backgroundColor:'+$_.find(TestElementStatuses,e => e.value == element.status).color" v-if="element.status !== 'pending'"></span>
                                            </v-flex>
                                            <v-flex class="item-status">Dernière modification le {{moment(element.updated_at).format('DD/MM/YYYY')}}</v-flex>
                                            <v-flex class="item-status">{{getStatus(element,index)}}</v-flex>
                                        </v-layout>
                                    </a>
                                </li>
                            </ul>
                        </v-layout>
                    </li>
                    <!-- then recap -->
                    <li class="item">
                        <a @click="selectRequest()">
                            <v-layout column justify-space-around align-content-space-around :class="{'current-item':final == true, 'item-container': true}">
                                <v-flex class="item-title">
                                    Récapitulatif
                                </v-flex>
                            </v-layout>
                        </a>
                    </li>

                </ul>
            </div>
        </div>
        <!-- #endregion -->

        <!-- #region Content -->
        <div class="loader" v-if="loadingRequests">
            <img src="../../../assets/img/grid_loader.svg"/>
        </div>
        <div class="content-container scroll-y" id="scroll-container" v-if="!loadingRequests">
            <!-- #region -- Technical Caracts -->
            <div v-scroll="{target: '#scroll-container'}" v-if="$_.find(requests, r => r.title == 'Features_'+params.product_id) && selectedRequest.id == $_.find(requests, r => r.title == 'Features_'+params.product_id).id && final == false">
                <v-flex xs10 offset-xs1 class="pt-5">
                    <v-layout column>
                        <h2 class="mb-3">Produit : </h2>
                        <v-flex xs5 mb-5>
                            <v-layout row wrap class="feature_info">
                                <div @click="$eventHub.$emit('view-file', product.photo, 'avatar')" class="mr-4 zoom">
                                    <avatar :item="product" size="15rem" field="photo" v-if="product"></avatar>
                                </div>
                                <div>
                                    <p>
                                        <span>Label: </span>
                                        <span>{{product_name}}</span>
                                    </p>
                                    <p>
                                        <span>Code: </span>
                                        <span>{{product.code}}</span>
                                    </p>
                                    <p>
                                        <span>Ean: </span>
                                        <span>{{product.ean}}</span>
                                    </p>
                                </div>
                                <v-checkbox v-model="selected_carac" :value="0" :disabled="test_status != null && test_status != 'pending'" @change="setStatus"></v-checkbox>
                            </v-layout>
                        </v-flex>
                        <h2 class="mb-3">Caractéristiques : </h2>
                        <v-flex v-for="(field,index) in fields" :key="index" xs5>
                            <v-layout row wrap class="features" v-if="field.pivot && field.pivot.is_visible == 1">
                                <p>
                                    <span>{{field.label}}</span>
                                    <span v-if="field.pivot">{{field.pivot.value}}</span>
                                </p>
                                <v-checkbox v-model="selected_carac" :value="field.id" :disabled="test_status != null && test_status != 'pending'" @change="setStatus"></v-checkbox>
                            </v-layout>
                            <v-layout row wrap class="features" v-else-if="field.is_exportable == 1">
                                <p>
                                    <span>{{field.label}}</span>
                                    <span>{{field.value}}</span>
                                </p>
                                <v-checkbox v-model="selected_carac" :value="field.id" :disabled="test_status != null && test_status != 'pending'" @change="setStatus"></v-checkbox>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <div class="invalidation-box mt-3" v-if="final == false && model.status === 'failed' && display && (selectedRequest.status == 'pending' || selectedRequest.status == null)">
                        <div class="invalidation-comment">
                            <v-text-field
                              name='message_text_field'
                              label="Votre remarque (laissez vide si vous n'en avez pas)"
                              hint=''
                              v-model='selectedRequest.comment'
                              multi-line
                              rows="2"
                              class='comment-text'>
                            </v-text-field>
                            <v-layout class="comment-text">
                                <div v-for="(file,index) in selectedRequest.invalidation_files" :key="file.id" class="mr-2">
                                    <v-menu offset-y content-class="files" style="zIndex:204">
                                        <div slot="activator">
                                            <label class="invalidation-image">
                                                <v-icon class="hover-alpha">mode_edit</v-icon>
                                                <img :src="file.path" @click="$eventHub.$emit('view-file',file)"/>
                                            </label>
                                        </div>
                                       <v-list>
                                           <v-list-tile class="li">
                                               <label :for="'file-input-'+index">Modifier l'image</label>
                                               <input class="input-img" style="display:none" :id="'file-input-'+index" type="file" @change="(event)=>{onFileChange(event,index)}"/>
                                           </v-list-tile>
                                           <v-list-tile @click="deleteImg(index)" class="li">
                                               <v-list-tile-title>Supprimer l'image</v-list-tile-title>
                                           </v-list-tile>
                                       </v-list>
                                    </v-menu>
                                </div>
                                <div v-if="!selectedRequest.invalidation_files || selectedRequest.invalidation_files.length < 2" class="mr-2">
                                    <v-menu offset-y content-class="files" style="zIndex:204">
                                        <div slot="activator">
                                            <label class="invalidation-image">
                                                <img :src="addImgPath()" class="add-image"/>
                                            </label>
                                        </div>
                                       <v-list>
                                           <v-list-tile>
                                               <label :for="'file-input'">Ajouter une image</label>
                                               <input class="input-img" style="display:none" id="file-input" type="file" @change="(event)=>{onFileChange(event)}"/>
                                           </v-list-tile>
                                       </v-list>
                                    </v-menu>
                                </div>
                            </v-layout>
                        </div>
                    </div>
                    <div class="invalidation-box mt-3" v-if="final == true && this.selectedRequest.status === 'failed' && ((!!this.selectedRequest.comment && this.selectedRequest.comment!=='') || (!!this.selectedRequest.invalidation_files && this.selectedRequest.invalidation_files.length>0))">
                        <div class="invalidation-comment">
                            <div class='comment-text'>
                                  {{selectedRequest.comment}}
                            </div>
                            <v-layout class="comment-text">
                                <div v-for="(file,index) in selectedRequest.invalidation_files" :key="file.id" class="mr-2">
                                    <label class="comment-image">
                                        <img :src="file.path" @click="$eventHub.$emit('view-file',file)"/>
                                    </label>
                                </div>
                            </v-layout>
                        </div>
                    </div>
                </v-flex>
            </div>
            <!-- #endregion -->

            <!-- #region -- Accessories -->

            <div v-scroll="{target: '#scroll-container'}" v-if="$_.find(requests, r => r.title == 'Accessories_'+params.product_id) && selectedRequest.id == $_.find(requests, r => r.title == 'Accessories_'+params.product_id).id && final == false">
                <v-flex xs10 offset-xs1 class="pt-5">
                    <v-layout column>
                        <h2 class="mb-3">Accessoires : </h2>
                        <h3 class="mb-3">De série : </h3>
                        <v-flex v-for="(accessory,index) in accessoriesList" :key="index" xs5 v-if="accessory.de_serie != null">
                            <v-layout row wrap class="accessories">
                                <div>
                                    <div @click="accessory.photo ? $eventHub.$emit('view-file', accessory.photo, 'avatar') : ''" :class="{'zoom' : accessory.photo}">
                                        <avatar :item="accessory" field="photo" size="3rem"></avatar>
                                    </div>
                                    <p class="caract_title mb-0">{{accessory.label}}</p>
                                    <p class="caract_title mb-0" style="margin-left:3rem">{{accessory.label_2}}</p>
                                </div>
                                <v-checkbox v-model="selected_accessory" :value="accessory.id" :disabled="test_status != null && test_status != 'pending'" @change="setStatus"></v-checkbox>
                            </v-layout>
                        </v-flex>
                        <h3 class="mb-3">Option : </h3>
                        <v-flex v-for="(accessory,index) in accessoriesList" :key="index" xs5 v-if="accessory.de_serie == null">
                            <v-layout row wrap class="accessories">
                                <div>
                                    <div @click="accessory.photo ? $eventHub.$emit('view-file', accessory.photo, 'avatar') : ''" :class="{'zoom' : accessory.photo}">
                                        <avatar :item="accessory" field="photo" size="3rem"></avatar>
                                    </div>
                                    <p class="caract_title mb-0">{{accessory.label}}</p>
                                    <p class="caract_title mb-0" style="margin-left:3rem">{{accessory.label_2}}</p>
                                </div>
                                <v-checkbox v-model="selected_accessory" :value="accessory.id" :disabled="test_status != null && test_status != 'pending'" @change="setStatus"></v-checkbox>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <div class="invalidation-box mt-3" v-if="final == false && selectedRequest.status === 'failed' && display && (selectedRequest.status == 'pending' || selectedRequest.status == null)">
                        <div class="invalidation-comment">
                            <v-text-field
                              name='message_text_field'
                              label="Votre remarque (laissez vide si vous n'en avez pas)"
                              hint=''
                              v-model='selectedRequest.comment'
                              multi-line
                              rows="2"
                              class='comment-text'>
                            </v-text-field>
                            <v-layout class="comment-text" >
                                <div v-for="(file,index) in selectedRequest.invalidation_files" :key="file.id" class="mr-2">
                                    <v-menu offset-y content-class="files" style="zIndex:204">
                                        <div slot="activator">
                                            <label class="invalidation-image">
                                                <v-icon class="hover-alpha">mode_edit</v-icon>
                                                <img :src="file.path" @click="$eventHub.$emit('view-file',file)"/>
                                            </label>
                                        </div>
                                       <v-list>
                                           <v-list-tile class="li">
                                               <label :for="'file-input-'+index">Modifier l'image</label>
                                               <input class="input-img" style="display:none" :id="'file-input-'+index" type="file" @change="(event)=>{onFileChange(event,index)}"/>
                                           </v-list-tile>
                                           <v-list-tile @click="deleteImg(index)" class="li">
                                               <v-list-tile-title>Supprimer l'image</v-list-tile-title>
                                           </v-list-tile>
                                       </v-list>
                                    </v-menu>
                                </div>
                                <div v-if="!selectedRequest.invalidation_files || selectedRequest.invalidation_files.length < 2" class="mr-2">
                                    <v-menu offset-y content-class="files" style="zIndex:204">
                                        <div slot="activator">
                                            <label class="invalidation-image">
                                                <img :src="addImgPath()" class="add-image"/>
                                            </label>
                                        </div>
                                       <v-list>
                                           <v-list-tile>
                                               <label :for="'file-input'">Ajouter une image</label>
                                               <input class="input-img" style="display:none" id="file-input" type="file" @change="(event)=>{onFileChange(event)}"/>
                                           </v-list-tile>
                                       </v-list>
                                    </v-menu>
                                </div>
                            </v-layout>
                        </div>
                    </div>
                    <div class="invalidation-box mt-3" v-if="final == true && this.selectedRequest.status === 'failed' && ((!!this.selectedRequest.comment && this.selectedRequest.comment!=='') || (!!this.selectedRequest.invalidation_files && this.selectedRequest.invalidation_files.length>0))">
                        <div class="invalidation-comment">
                            <div class='comment-text'>
                                  {{selectedRequest.comment}}
                            </div>
                            <v-layout class="comment-text">
                                <div v-for="(file,index) in selectedRequest.invalidation_files" :key="file.id" class="mr-2">
                                    <label class="comment-image">
                                        <img :src="file.path" @click="$eventHub.$emit('view-file',file)"/>
                                    </label>
                                </div>
                            </v-layout>
                        </div>
                    </div>
                </v-flex>
            </div>
            <!-- #endregion -->

            <!-- #region -- Requests & comments -->
            <div v-scroll="{target: '#scroll-container'}" v-if="final == false && selectedRequest.title && !selectedRequest.title.includes(params.product_id) || final == false && !selectedRequest.title">

                <!-- #region -- valide or not request -->
                <template>
                    <div class="status-choice-bar">
                        <v-layout class="all-choices-container">
                            <v-layout column>
                                <v-layout column class="one-choice-container" >
                                    <div class="button-title" v-if="model.status === 'failed'">
                                        Non validé
                                    </div>
                                    <div class="button-title" v-else>
                                    </div>
                                    <div class="text-xs-center">
                                        <v-btn @click="setStatus('failed')" outline large fab :class="{
                                            'status-choice-button': true,
                                            'failed': model.status === 'failed',
                                            'not-selected': model.status !== 'failed'}">
                                            <v-icon>clear</v-icon>
                                        </v-btn>
                                    </div>
                                </v-layout>
                            </v-layout>
                            <v-layout column>
                                <v-layout column class="one-choice-container">
                                    <div class="button-title" v-if="model.status === 'validated'">
                                        Validé
                                    </div>
                                    <div class="button-title" v-else>
                                    </div>
                                    <div class="text-xs-center">
                                        <v-btn @click="setStatus('validated')" outline large fab :class="{
                                            'status-choice-button': true,
                                            'validated': model.status === 'validated',
                                            'not-selected': model.status !== 'validated'}">
                                            <v-icon>done</v-icon>
                                        </v-btn>
                                    </div>
                                </v-layout>
                            </v-layout>
                        </v-layout>
                    </div>
                </template>
                <!-- #endregion -->

                <div class="content-text" :class="[selectedRequest.nbCol === 2 ? 'doubleCol' : '']">
                    <v-layout row>
                        <v-flex :class="selectedRequest.nbCol === 2 ? 'sm12 md6' : 'xs12'">
                            <div class="request-title on-left">
                                {{selectedRequest.title}}
                            </div>
                        </v-flex>
                        <v-flex v-if="selectedRequest.nbCol===2" sm12 md6>
                            <div class="request-title on-right">
                                {{selectedRequest.title_2}}
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex :class="selectedRequest.nbCol===2 ? 'sm12 md6' : 'xs12'">
                            <div class="request-message on-left">
                                {{selectedRequest.message}}
                            </div>
                        </v-flex>
                        <v-flex v-if="selectedRequest.nbCol===2" sm12 md6>
                            <div class="request-message on-right">
                                {{selectedRequest.message_2}}
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex :class="selectedRequest.nbCol===2 ? 'sm12 md6' : 'xs12'">
                            <v-layout wrap>
                                <div v-for="(file,index) in selectedRequest.files_1" :key="file.id" class="mr-2">
                                    <label class="comment-image">
                                        <img :src="file.path" @click="$eventHub.$emit('view-file',file)"/>
                                    </label>
                                </div>
                            </v-layout>
                        </v-flex>
                        <v-flex v-if="selectedRequest.nbCol===2" sm12 md6 >
                            <v-layout wrap>
                                <div v-for="(file,index) in selectedRequest.files_2" :key="file.id" class="mr-2">
                                    <label class="comment-image">
                                        <img :src="file.path" @click="$eventHub.$emit('view-file',file)"/>
                                    </label>
                                </div>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap class="mt-3 mb-3">
                        <!-- #region -- view attachment files -->
                        <template v-for="(file,index) in selectedRequest.attachment_files">
                            <div class='files-list-container' @click="$eventHub.$emit('view-file',file,selectedRequest.attachment_files)">
                                <div class="files-list-container-title">
                                    Pièces jointes :
                                </div>
                                <template>{{file.label}}.{{file.type}}</template>
                            </div>
                        </template>
                        <!-- #endregion -->
                    </v-layout>
                </div>
                <!-- #region -- invalidation box -->
                <div class="invalidation-box mt-2" v-if="final == false && selectedRequest.title && !selectedRequest.title.includes($route.params.id) && model.status === 'failed' && display">
                    <div class="invalidation-comment" >
                        <v-text-field
                        name='message_text_field'
                        label="Votre remarque (laissez vide si vous n'en avez pas)"
                        hint=''
                        v-model="selectedRequest.comment"
                        multi-line
                        rows="2"
                        class='comment-text'>
                        </v-text-field>
                        <v-layout class="comment-text" >
                            <div v-for="(file,index) in selectedRequest.invalidation_files" :key="file.id" class="mr-2">
                                <v-menu offset-y content-class="files" style="zIndex:204">
                                    <div slot="activator">
                                        <label class="invalidation-image">
                                            <v-icon class="hover-alpha">mode_edit</v-icon>
                                            <img :src="file.path" @click="$eventHub.$emit('view-file',file)"/>
                                        </label>
                                    </div>
                                   <v-list>
                                       <v-list-tile class="li">
                                           <label :for="'file-input-'+index">Modifier l'image</label>
                                           <input class="input-img" style="display:none" :id="'file-input-'+index" accept="image/*" capture="camera" type="file" @change="(event)=>{onFileChange(event,index)}"/>
                                       </v-list-tile>
                                       <v-list-tile @click="deleteImg(index)" class="li">
                                           <v-list-tile-title>Supprimer l'image</v-list-tile-title>
                                       </v-list-tile>
                                   </v-list>
                                </v-menu>
                            </div>
                            <div v-if="!selectedRequest.invalidation_files || selectedRequest.invalidation_files.length < 2" class="mr-2">
                                <v-menu offset-y content-class="files" style="zIndex:204">
                                    <div slot="activator">
                                        <label class="invalidation-image">
                                            <img :src="addImgPath()" class="add-image"/>
                                        </label>
                                    </div>
                                   <v-list>
                                       <v-list-tile>
                                           <label :for="'file-input'">Ajouter une image</label>
                                           <input class="input-img" style="display:none" id="file-input" accept="image/*" capture="camera" type="file" @change="(event)=>{onFileChange(event)}"/>
                                       </v-list-tile>
                                   </v-list>
                                </v-menu>
                            </div>
                        </v-layout>
                    </div>
                </div>
                <div class="invalidation-box" v-if="final == true && this.selectedRequest.status === 'failed' && ((!!this.selectedRequest.comment && this.selectedRequest.comment!=='') || (!!this.selectedRequest.invalidation_files && this.selectedRequest.invalidation_files.length>0))">
                    <div class="invalidation-comment">
                        <div class='comment-text'>
                              {{selectedRequest.comment}}
                        </div>
                        <v-layout class="comment-text">
                            <div v-for="(file,index) in selectedRequest.invalidation_files" :key="file.id" class="mr-2">
                                <label class="comment-image">
                                    <img :src="file.path" @click="$eventHub.$emit('view-file',file)"/>
                                </label>
                            </div>
                        </v-layout>
                    </div>
                </div>
                <!-- #endregion -->
                <!-- #endregion -->
            <!-- #endregion -->
            </div>

            <!-- #region -- Valid Test  -->
                <div v-scroll="{target: '#scroll-container'}" v-if="final == true">
                    <v-flex xs10 offset-xs1 class="pt-5">
                        <v-layout column>

                            <p class="score">
                                <span class="numbers">
                                    <span class="success--text" v-if="requests.length - requests.filter(r => r.status == 'failed').length == requests.length">{{requests.length - requests.filter(r => r.status == 'failed').length}}</span>
                                    <span v-else class="error--text">{{requests.length - requests.filter(r => r.status == 'failed').length}}</span>
                                    / {{requests.length}}
                                </span>
                                <span>
                                    Points validés
                                </span>
                            </p>
                            <h2 class="mt-2">Récapitulatif :</h2>

                            <template v-for="request in requests.filter(r => r.status == 'failed')">
                                <div v-if="request.title.includes('Features')" class="recap">
                                    <p class="mb-0">Caractéristiques :</p>
                                    <template v-if="request.message" v-for="id in request.message.split(',').map(Number)">
                                        <span v-if="$_.find(fields, c => c.id == id)">{{$_.find(fields, c => c.id == id).label}}</span>
                                        <span v-else-if="!$_.find(caracts, c => c.id == id)">Infos générales du produit</span>
                                    </template>
                                </div>
                                <div v-if="request.title.includes('Accessories')" class="recap">
                                    <p class="mb-0">Accessoires :</p>
                                    <template v-if="request.message" v-for="id in request.message.split(',').map(Number)">
                                        <span v-if="$_.find(accessoriesList, c => c.id == id)">{{$_.find(accessoriesList, c => c.id == id).label}}</span>
                                    </template>
                                </div>
                            </template>
                            <div v-if="failedRequests.length > 0" class="recap">
                                <p class="mb-0">Demandes :</p>
                                <template v-for="faile in failedRequests">
                                    <span>{{faile.title}}</span>
                                </template>
                            </div>
                            <v-layout row wrap class="mt-5 pt-5">
                                <v-flex xs10 offset-xs1 mb-2>
                                    <v-text-field
                                      label="Commentaire"
                                      v-model="final_comment"
                                      multi-line
                                      auto-grow
                                      :rows="5"
                                      :disabled="params.read_only == true"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs10 offset-xs1>
                                    <v-select
                                      :items="TestStatuses.filter(ts => ts.value != 'pending')"
                                      item-text="label"
                                      item-value="value"
                                      v-model="test_status"
                                      label="Choisir le status du test"
                                      content-class="menu-status"
                                      :disabled="params.read_only == true"
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                        </v-layout>
                    </v-flex>
                </div>
            <!-- #endregion -->
        </div>
        <!-- #endregion Content -->

        <!-- #region footer -->
        <div class="modal-footer">
            <v-btn :disabled="model.status === 'pending'" :depressed="model.status!=='pending'" v-if="test_status != 'finished' && test_status != 'failed' && final != true" round depressed small
            :color="'primary'" @click="saveRequest()" :loading="loading"
            class="footer-button">Enregistrer &
                <template v-if="selectedRequest.index !== requests.length-1">Demande suivante</template>
                <template v-else>Voir le récapitulatif</template>
            </v-btn>
            <v-btn :disabled="test_status == 'pending'" :depressed="model.status!=='pending'" :loading="loading" v-else round depressed small
            :color="'primary'" @click="saveRequest(true)"
            class="footer-button">Enregistrer & Fermer
            </v-btn>
        </div>
        <!-- #endregion footer -->

        <div v-if="imgFullPath !== null" class="overlay">
            <div class="overlay-container">
                <img :src="imgFullPath" class="overlay-image" />
            </div>
        </div>

    </div>
</template>


<script>
import Avatar   from '../../../components/avatar/Avatar.vue'
import { TestElementStatuses } from '../../../config/enum/TestElementStatuses'
import { TestStatuses } from '../../../config/enum/TestStatuses'
import moment from 'moment'
moment.locale('fr')

export default {
    components: {
        Avatar
    },
    props: {
        params: {
            required: true,
        }
    },
    data() {
        return {
            test_id: null,
            imgFullPath:null,
            selectedRequest: {
                id: 0,
                comment: '',
                status: 'pending',
                invalidation_files:  [],
                files_1: [],
                files_2:  [],
            },
            moment,
            first_not_saved: 0,
            product_name: '',
            valid_button: false,
            cancel_button: false,
            fullscreen: true,
            card_text_class: 'fullscreen-modal-text',
            requests: [],
            model: {
                status: 'pending',
                comment: '',
                invalidation_files: [],
            },
            TestElementStatuses,
            TestStatuses,
            display:true,
            test_status: null,
            selected_carac : [],
            caracts: [],
            selected_accessory : [],
            accessories: [],
            final: false,
            product: '',
            loading: false,
            loadingRequests: false,
            final_comment:null,
        }
    },
    methods: {
        addImgPath() {
            return require('../../../assets/img/addimg.svg')
        },
        // delete image front teh invalidation comment
        deleteImg(fileIndex){
            this.display  = false
            let fileId    = undefined;
            //Get the id of the file to delete
            if (this.selectedRequest.invalidation_files[fileIndex] !== undefined) {
              fileId      = this.selectedRequest.invalidation_files[fileIndex].id;
            }
            if(fileId == undefined) {
              this.axios.get(`/api/elements/${this.selectedRequest.id}/file`).then(response => {
                fileId    = response[fileIndex] ? response[fileIndex].id : undefined;
              });
            }
            //Delete the file from DB and storage
            if (fileId) {
                this.axios.delete(`/api/elements/${this.selectedRequest.id}/file/${fileId}`)
                    .then(response => {
                    })
                    .catch(error => {
                        this.$eventHub.$emit('open-snackbar', 'error','Un problème est survenu lors de la suppression du fichier')
                    });
            } else {
                this.model.invalidation_files.splice(fileIndex,1);
            }
            //update the requests list
            let get_index                                 = this.requests.findIndex(r => r.id == this.selectedRequest.id)
            this.selectedRequest.invalidation_files.splice(fileIndex,1);
            this.requests[get_index].invalidation_files   = this.selectedRequest.invalidation_files;
            this.display                                  = true
        },
        // upload invalidation image
        onFileChange:function(evt,fileIndex){
            if (fileIndex >= 0){
                this.model.invalidation_files[fileIndex].path               = URL.createObjectURL(evt.target.files[0]);
                this.model.invalidation_files[fileIndex].file               = evt.target.files[0];
                this.model.invalidation_files[fileIndex].toUpdate           = true;

                this.selectedRequest.invalidation_files[fileIndex].path     = URL.createObjectURL(evt.target.files[0]);
                this.selectedRequest.invalidation_files[fileIndex].file     = evt.target.files[0];
                this.selectedRequest.invalidation_files[fileIndex].toUpdate = true;

                let get_index = this.requests.findIndex(r => r.id == this.selectedRequest.id)
                this.requests[get_index].invalidation_files = this.selectedRequest.invalidation_files;
            } else {
                this.model.invalidation_files.push({
                    path:URL.createObjectURL(evt.target.files[0]),
                    file:evt.target.files[0],
                    toUpdate:true
                });

                this.selectedRequest.invalidation_files.push({
                    path:URL.createObjectURL(evt.target.files[0]),
                    file:evt.target.files[0],
                    toUpdate:true
                });
            }
        },
        // get teh status of an element
        getStatus(element,index) {
            if (index < this.first_not_saved) {
                return ''
            } else if(element.status != null) {
                return ''
            } else {
                return ' - Non validé'
            }
        },
        // select the request
        selectRequest(index) {
            if(index != null || index != undefined) {
                // on click on item
                this.final = false
                let selectedRequestToCopy = this.requests[index]
                if(selectedRequestToCopy.status == null || selectedRequestToCopy.status == 'pending') {
                    this.first_not_saved = index
                }
                this.selectedRequest.id = selectedRequestToCopy.id
                this.model.status = selectedRequestToCopy.status ? selectedRequestToCopy.status : selectedRequest.status
                this.selectedRequest.status = this.model.status
                this.selectedRequest.title = selectedRequestToCopy.title
                this.selectedRequest.title_2 = selectedRequestToCopy.title_2
                this.selectedRequest.message = selectedRequestToCopy.message
                this.selectedRequest.message_2 = selectedRequestToCopy.message_2
                if(selectedRequestToCopy.title_2 !== '' && selectedRequestToCopy.message_2 !== '') {
                    this.selectedRequest.nbCol = 2;
                } else {
                    this.selectedRequest.nbCol = 1;
                }
                this.selectedRequest.index = index;
                this.selectedRequest.files_1 = selectedRequestToCopy.files_1;
                this.selectedRequest.files_2 = selectedRequestToCopy.files_2;
                this.selectedRequest.attachment_files = selectedRequestToCopy.attachment_files;
                this.selectedRequest.invalidation_files = selectedRequestToCopy.invalidation_files;
                this.selectedRequest.comment = selectedRequestToCopy.comment;
                if(this.selectedRequest.title.includes(this.params.product_id)){
                    if(this.selectedRequest.status == null || this.selectedRequest.status == 'pending') {
                        this.model.status = 'validated'
                    } else {
                        this.model.status = this.selectedRequest.status
                    }
                }
            } else {
                if(this.test_status != 'pending') {
                    this.final = true
                } else {
                    if(this.requests.filter(r => r.status != 'pending' && r.status != null).length == this.requests.length) {
                        this.final = true
                        // this.test_status = this.requests.filter(r => r.status == 'failed').length > 0 ? 'failed' : 'finished'
                        this.test_status = 'to_validate'
                    }
                }
            }
        },
        setStatus(status) {
            // set the sttaus of a request
            if(this.selectedRequest.title.includes('Features')){
                if(this.caracts.filter(x => !this.selected_carac.includes(x)).length > 0){
                    this.model.status = 'failed'
                } else {
                    this.model.status = 'validated'
                }
            } else {
                this.model.status = status;
            }
            //when invalidation box is open -- scroll to this one
            if(this.model.status == 'failed') {
                let body = document.querySelector('.content-container')
                setTimeout(() => {
                    body.scroll({
                      top: body.scrollHeight - body.clientHeight,
                      left: 0,
                      behavior: 'smooth'
                    });
                },5)
            }
        },
        saveRequest(save = false) {
            this.loading = true
            if(!save) {
                let data = {
                    status: this.model.status,
                    comment : this.model.status === 'failed' ? this.selectedRequest.comment : null
                };
                if(this.selectedRequest.title.includes(this.params.product_id)){
                    if(this.selectedRequest.title.includes('Features')) {
                        data.message = this.caracts.filter(x => !this.selected_carac.includes(x)).join(',')
                    } else {
                        data.message = this.accessories.filter(x => !this.selected_accessory.includes(x)).join(',')
                    }
                }
                this.axios.put(`/api/elements/${this.selectedRequest.id}`,data)
                    .then(response => {
                        let savePhotoRec =(index)=>{
                          if (this.model.invalidation_files[index]) {
                                let data = new FormData();
                                data.append('file',this.model.invalidation_files[index].file),
                                data.append('location','invalidation-comment');
                                data.append('size', 750);
                                this.axios.post(`/api/elements/${this.selectedRequest.id}/file`,data)
                                    .then(response => {
                                        savePhotoRec(++index);
                                    })
                                    .catch(err => console.log(err))
                            }
                        };
                        if (this.model.status === 'failed'){
                            savePhotoRec(0);
                        }
                        this.selectedRequest.status = this.model.status;
                        if(response.status === 200 || response.status === 204) {
                            let get_index = this.requests.findIndex(r => r.id == this.selectedRequest.id)
                            if(this.requests[get_index]) {
                                this.requests[get_index].comment            = this.selectedRequest.comment;
                                this.requests[get_index].invalidation_files = this.selectedRequest.invalidation_files;
                                this.requests[get_index].status             = this.selectedRequest.status;
                            }
                            // this.selectedRequest.invalidation_files =  this.model.invalidation_files;

                            this.first_not_saved++;
                            if(this.selectedRequest.index === this.requests.length-1) {
                                this.final = true
                                this.test_status = 'to_validate'
                                // if(this.requests.filter(r => r.status == 'failed').length > 0){
                                //     this.test_status = 'failed'
                                // }
                            } else {
                                this.model = {
                                    status: 'pending',
                                    comment: '',
                                    invalidation_files: []
                                }
                                this.selectNextRequest()
                            }
                            this.loading = false
                          }
                  })
            } else {
                this.axios.put(`/api/tests/${this.test_id}`, {status: this.test_status, final_comment:this.final_comment})
                    .then(response => {
                      this.onClose()
                      this.loading = false
                    })
            }
        },
        selectNextRequest() {
            let current_index = this.selectedRequest.index
            if(current_index < this.requests.length-1) {
                this.selectRequest(current_index+1);
            }
        },
        onClose() {
            this.$eventHub.$emit('close-modal');
            this.$eventHub.$emit('reload-list');
            this.$router.push({name: this.$route.name});
        },
        getElements() {
            this.loadingRequests = true
            this.axios.get(`/api/elements?filters=test_id|=|${this.test_id}&embed=files,symbol.files`)
                .then(response => {
                    this.requests = response.data.map((el=>{
                        el.files_1 = el.files.filter(file=>file.pivot.location === 'area-1' && file.pivot.file_type != 'attachment');
                        el.files_2 = el.files.filter(file=>file.pivot.location === 'area-2' && file.pivot.file_type != 'attachment');
                        el.attachment_files   = el.files.filter(file=>file.pivot.file_type === 'attachment');
                        el.invalidation_files = el.files.filter(file=>file.pivot.location === 'invalidation-comment');
                        return el;
                    }));

                    this.fields.forEach(f => { this.caracts.push(f.id)})
                    this.caracts.push(0)
                    this.selected_carac = this.caracts
                    if(this.$_.find(this.requests, r => r.title == 'Features_'+this.params.product_id) && this.$_.find(this.requests, r => r.title == 'Features_'+this.params.product_id).message){
                        let message = this.$_.find(this.requests, r => r.title == 'Features_'+this.params.product_id).message.split(',').map(Number)
                        this.selected_carac = this.caracts.filter(x => !message.includes(x))
                    }

                    this.accessoriesList.forEach(f => { this.accessories.push(f.id)})
                    this.selected_accessory = this.accessories
                    if(this.$_.find(this.requests, r => r.title == 'Accessories_'+this.params.product_id) && this.$_.find(this.requests, r => r.title == 'Accessories_'+this.params.product_id).message){
                        let message = this.$_.find(this.requests, r => r.title == 'Accessories_'+this.params.product_id).message.split(',').map(Number)
                        this.selected_accessory = this.accessories.filter(x => !message.includes(x))
                    }

                    let firstNotAnsweredIndex = this.requests.findIndex((el)=> {
                        return el.status === 'pending'
                    })
                    if(firstNotAnsweredIndex > -1) {
                        this.first_not_saved = firstNotAnsweredIndex;
                        this.selectRequest(firstNotAnsweredIndex);
                    } else {
                        this.first_not_saved = this.requests.length
                        if(!this.requests[this.first_not_saved - 1] || (this.requests[this.first_not_saved - 1].status == 'pending' || this.requests[this.first_not_saved - 1].status == null)){
                            this.selectRequest(0);
                        } else {
                            this.selectRequest();
                        }
                    }
                    this.loadingRequests = false
                })
        },
        get_product(){
            if(this.params.product_id){
                this.axios.get(`/api/products/${this.params.product_id}`)
                .then(response => {
                    this.product = response.data
                })
            }
        }
    },
    created() {
        this.product_name = this.params.product_label;
        this.get_product()
        // when it's new test
        if(this.params.run_new_test) {
            this.first_not_saved = 0;
            let test_to_post = {
                status: 'pending',
                user_id: this.$store.state.auth.user.id,
                product_id: this.params.product_id
            };

            this.axios.post(`/api/tests`,test_to_post)
                .then(response => {
                    this.test_id = response.data.id;
                    this.getElements();
                })
        } else if(this.params.id) {
            // else to read or continue one
            this.test_id = this.params.id
            this.test_status = this.params.status
            this.final_comment = this.params.final_comment
            this.getElements();
        }
    },
    computed: {
        fields() {
            let fields = this.$store.state.single.data.fields
            fields = this.$_.orderBy(fields, f => {
                return f.pivot.position
            })
            return fields.concat(this.$store.state.single.data.features)
        },
        accessoriesList() {
            return this.$store.state.single.data.accessories
        },
        failedRequests(){
            let request = []
            this.requests.filter(r => r.status == 'failed').forEach(rr => {
                if(!rr.title.includes(this.params.product_id)){
                    request.push(rr)
                }
            })
            return request
        }
    }
}
</script>

<style lang="stylus" scoped>
    @require '../../../assets/css/variables'
    .files {
        label {
            font-size: 1.6rem
            height: 100%
            width: 100%
            display: flex
            align-items: center
            cursor: pointer
        }
    }

    $header-hight = 60px
    $bottom-hight = 91px
    $aside-width = 317px
    $content-side-padding = 115px
    .modal-header {
        display:flex
        justify-content: flex-start
        align-items center
        z-index: 2
        height: $header-hight
        background: white
        box-shadow: 0 0 33px 0 #EBEFF5 !important

        div.app-logo {
            height: $app-nav-width
            display: flex
            align-items:center
            justify-content:center
            border-right: 1px solid $border-light-color
            border-bottom: 1px solid $border-light-color
            padding: 0 2.5rem
            margin-left: 0 !important

            img {
                max-width: 100%
            }
        }

        & >>> button.btn {
            padding: 0
            margin:0
            min-width: auto
            height: 100%
        }

    }
    .invalidation-box {
        border: 1px solid #E7EAF6;
        border-radius: 10px;
        background-color: #F7F8FD;
        margin: 0 11rem 2rem
        padding: 1rem 3rem
        .invalidation-comment {
            input {
                display: none;
            }
            .invalidation-image {
                margin-top: 25px
                height: 100px
                width: 100px
                box-shadow: 0px 4px 6px #aaa
                margin-bottom: 10px
                background-color: rgba(0,0,0,0.68)
                cursor: pointer
                display: block
                img {
                    width:100%
                    height:100%
                    object-fit: contain
                    background-color: #FFF
                    &.add-image {
                        padding: 20px !important
                        background-color: rgba(0, 0, 0, 0.5)
                    }
                }
                .hover-alpha {
                    height: 100%
                    width: 100%
                    position: absolute
                    margin-bottom: 35px
                    &:not(hover) {
                        background-color: rgba(0, 0, 0, 0);
                        color: rgba(0, 0, 0, 0);
                    }
                    &:hover {
                        background-color: rgba(0, 0, 0, 0.5);
                        color: white;
                    }
                }
            }
            .comment-text{
                margin: 0
                width: 100%
                font-size: 1.7rem
            }
        }
    }

    .comments-aside {
        z-index: 1
        position: fixed;
        top: $header-hight
        bottom: $bottom-hight
        left: 0
        width: $aside-width
        padding: 0
        overflow-y: scroll
        margin: 0
        padding-top: 30px
        box-shadow: inset -1px -1px 0 0 #ECEFF5, 15px 2px 21px 0 #FAFAFC;
        a {
            text-decoration:none;
        }
        .current-item{
            background-color: $primary-color
            color:white !important
        }
        .item-container{
            color :black
            padding: 8px 15px 8px 15px
            margin: 0
        	box-shadow: inset 0 -1px 0 0 rgba(236,243,246,0.5), 0 2px 2px 0 rgba(233,237,245,0.5)
            z-index: 2 !important
            .item-title {
                font-size:1.6rem
                overflow: hidden
                display: flex
                line-height: 200%
                align-items: center
                p {
                    overflow: hidden
                    white-space: nowrap
                    text-overflow: ellipsis
                }
                span.status {
                    display: block
                    width: 2rem
                    min-width: 2rem
                    height: 2rem
                    border-radius: 1rem
                }
            }
            ul {
                li {
                    list-style-type: none
                }
            }
            .item-status {
                font-size:1rem
            }
            .item-user {
                font-size:1.2rem
            }
        }
        @media screen and (max-width: 900px){
            display: none;
        }
    }
    .loader {
        position: fixed
        top: $header-hight
        bottom: $bottom-hight
        left: $aside-width
        right: 0
        background: white
        z-index: 0
        padding: 0
        margin: 0
        display: flex
        align-items: center
        justify-content: center
    }
    .content-container {
        position: fixed
        top: $header-hight
        bottom: $bottom-hight
        left: $aside-width
        right: 0
        background: white
        z-index: 0
        padding: 0
        margin: 0
        .feature_info {
            display: flex
            align-items: center
            justify-content: space-between;
            p {
                font-size: 1.5rem
                margin-bottom: 0
                span{
                    &:last-of-type{
                        font-weight: bold
                    }
                }
            }
            .input-group {
                flex-wrap: nowrap
                flex: 0
            }
        }
        .features {
            display: flex
            align-items: center
            justify-content: space-between
            min-height: 5rem
            p {
                font-size: 1.7rem
                width: 85%
                overflow:hidden
                margin-right: 5rem
                display: flex
                align-items: center
                justify-content: space-between
                margin-bottom: 0
                span{
                    &:first-of-type{
                        display: block
                        margin-right: 1rem
                    }
                    &:last-of-type{
                        font-weight: bold
                        word-break: break-word
                        text-align: right
                    }
                }
            }
            .input-group {
                flex-wrap: nowrap
                flex: 0
            }
        }
        .accessories {
            display: flex
            align-items: center
            justify-content: space-between
            min-height: 5rem
            div {
                display: flex
                align-items: center
                & > .avatar {
                    margin-right: 2rem
                }
            }
            .input-group {
                flex-wrap: nowrap
                flex: 0
            }
        }
        .status-choice-bar {
            position: relative
            margin-top: 32px
            height: 90px
            .all-choices-container {
                position: absolute;
                right: 60px
                width: 180px
                text-align: center;
                justify-content: center;
                .one-choice-container {
                    width: 90px
                    .button-title {
                        font-family: Muli
                        font-size: 16px;
                        color: #97A4B4;
                        height: 16px
                    }
                    .status-choice-button {
                        height: 51px !important
                        width: 51px !important
                        border-radius: 50%
                        border-width: medium;
                        background: white !important
                        &.failed{
                            color: #FF456E
                            border-color: #FF456E
                        }
                        &.validated{
                            color: #7ED321
                            border-color: #7ED321
                        }
                        &.not-selected{
                            color: #DBDBDB
                            border-color: #DBDBDB
                        }
                    }
                }
            }
        }
        .comment-image {
            margin-top: 25px
            height: 100px
            width: 100px
            box-shadow: 0px 4px 6px #aaa
            margin-bottom: 10px
            background-color: rgba(0,0,0,0.68)
            cursor: pointer
            display: block
            img {
                width:100%
                height:100%
                object-fit: contain
                background-color: #FFF
                &.add-image {
                    padding: 20px !important
                    background-color: rgba(0, 0, 0, 0.5)
                }
            }
        }
        .content-text {
            padding-left: $content-side-padding
            padding-right: $content-side-padding
            padding-top: 0
            padding-bottom: 0
            .request-title {
                padding-bottom: 70px
                padding-top: 1rem
                font-size: 2.5rem
                &.on-left {
                    padding-right: 1rem
                }
                &.on-right {
                    padding-left: 1rem
                }
            }
            .request-message {
                padding-bottom: 0
                font-size: 1.5rem
                margin-bottom: 1rem
                &.on-left {
                    padding-right: 1rem
                }
                &.on-right {
                    padding-left: 1rem
                }
            }
        }
        @media screen and (max-width: 900px){
            width: 100%
            position: inherit
            .content-text {
                &.doubleCol {
                    height: -webkit-fill-available
                    .layout {
                        flex-direction: column
                        height: 10rem
                        .flex {
                            &:last-of-type{
                                position: relative
                                top: 30rem
                            }
                        }
                        &.row {
                            &:nth-of-type(2){
                                .flex {
                                    &:last-of-type{
                                        position: relative
                                        top: 40rem
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .modal-footer {
        position: fixed
        background: white
        bottom: 0
        left: 0
        right: 0
        margin: 0
        padding: 0
        z-index: 2
        height: $bottom-hight
        box-shadow: 0 -1px 4px 0 #EAECF3 !important
        .footer-button {
            position: absolute
            top: 26px
            right: 125px
            font-size: 14px
        }
    }

    .score {
        text-align: center
        padding-top: 2rem
        font-size: 1.5rem
        display: flex
        align-items: center
        justify-content: center
        flex-direction: column
        span.numbers {
            font-size: 5rem
        }
    }
    .recap {
        p {
            margin-top: 1rem
            font-size: 1.7rem
            font-weight: 600
        }
        span {
            display: block
            margin-left: 2rem
            font-size: 1.4rem
        }
    }
    .files-list-container {
        padding: 1rem 1.5rem
        position: relative
        margin-top: 15px
        background: #eee
        font-size: 1.7rem
        border-radius: 5px
        border-width: 2px
        border-color: blue
        width: 'calc(100% - (%s * 2) + 2rem)' % $content-margin
        color: $primary-color
        display: inline-flex
        font-weight: bold
        align-items: center
        cursor: pointer
        width: 100%
        .files-list-container-title {
            font-style: italic
            color: black
            padding-right: 1rem
            font-weight: normal
        }
    }
    .unclick {
        opacity: 0.5
    }
</style>
<style lang="stylus">
.menu-status {
    z-index: 210!important
}
</style>



// WEBPACK FOOTER //
// src/views/products/single/RunTest.vue